// src/features/stock/constants/stockAreas.jsx
import AnalyticsIcon from "@mui/icons-material/Analytics";
import AssessmentIcon from "@mui/icons-material/Assessment";
import CompareArrowsIcon from "@mui/icons-material/CompareArrows";
import DashboardIcon from "@mui/icons-material/Dashboard";
import DateRangeIcon from "@mui/icons-material/DateRange";
import DinnerDiningIcon from "@mui/icons-material/DinnerDining";
import FactCheckIcon from "@mui/icons-material/FactCheck";
import FactoryIcon from "@mui/icons-material/Factory";
import FunctionsIcon from "@mui/icons-material/Functions";
import Inventory2Icon from "@mui/icons-material/Inventory2";
import LeaderboardIcon from "@mui/icons-material/Leaderboard";
import NotificationsActiveIcon from "@mui/icons-material/NotificationsActive";
import PaidIcon from "@mui/icons-material/Paid";
import PlaylistAddCheckIcon from "@mui/icons-material/PlaylistAddCheck";
import ReceiptLongIcon from "@mui/icons-material/ReceiptLong";
import SavingsIcon from "@mui/icons-material/Savings";
import ShowChartIcon from "@mui/icons-material/ShowChart";
import StorageIcon from "@mui/icons-material/Storage";
import SyncAltIcon from "@mui/icons-material/SyncAlt";
import UploadFileIcon from "@mui/icons-material/UploadFile";

const stockBasePath = "/stock";

export const stockSections = [
  {
    key: "base-de-datos",
    path: "base-de-datos",
    icon: <StorageIcon />,
    label: "Base de Datos",
    areaLabel: "Área Base de Datos",
    description:
      "Administra productos, proveedores, recetas y datos maestros del inventario.",
    children: [
      {
        path: "insumos",
        icon: <Inventory2Icon />,
        label: "Insumos",
        description:
          "Gestiona materias primas, unidades de medida y datos operativos.",
      },
      {
        path: "elaborados",
        icon: <FactoryIcon />,
        label: "Elaborados",
        description:
          "Administra preparaciones internas, rendimientos y componentes productivos.",
      },
      {
        path: "productos-de-venta",
        icon: <DinnerDiningIcon />,
        label: "Productos de venta",
        description:
          "Administra productos ofrecidos al cliente, su composición y sus costos.",
      },
    ],
  },
  {
    key: "operacion",
    path: "operacion",
    icon: <SyncAltIcon />,
    label: "Operación",
    areaLabel: "Área Operación",
    description:
      "Registra compras, producción, conteos y movimientos diarios.",
    children: [
      {
        path: "compras",
        icon: <ReceiptLongIcon />,
        label: "Compras",
        description:
          "Carga compras, remitos, precios y cantidades recibidas por proveedor.",
      },
      {
        path: "stock",
        icon: <Inventory2Icon />,
        label: "Stock",
        allowedRoles: ["OWNER", "CONSULTORA", "MANAGER"],
        description:
          "Consulta existencias actuales de insumos y elaborados por sector.",
      },
      {
        path: "produccion-elaborados",
        icon: <FactoryIcon />,
        label: "Producción Elaborados",
        allowedRoles: ["OWNER", "CONSULTORA", "MANAGER"],
        description:
          "Registra producción interna y descuenta insumos según recetas activas.",
      },
      {
        path: "conteo-de-stock",
        icon: <FactCheckIcon />,
        label: "Conteo de Stock",
        allowedRoles: ["OWNER", "CONSULTORA", "MANAGER"],
        description:
          "Realiza inventarios físicos, cierres de conteo y validaciones de stock.",
      },
      {
        path: "ventas-importadas",
        icon: <UploadFileIcon />,
        label: "Ventas Importadas",
        allowedRoles: ["OWNER", "CONSULTORA", "MANAGER"],
        description:
          "Importa ventas externas para calcular consumos y actualizar indicadores.",
      },
    ],
  },
  {
    key: "analisis",
    path: "analisis",
    icon: <AnalyticsIcon />,
    label: "Análisis",
    areaLabel: "Área Análisis",
    description:
      "Consulta consumos, CMV, desvíos, impacto económico y pedidos sugeridos.",
    children: [
      {
        path: "consumo-teorico",
        icon: <FunctionsIcon />,
        label: "Consumo Teórico",
        description:
          "Calcula el consumo esperado según ventas, recetas y rendimientos definidos.",
      },
      {
        path: "consumo-real",
        icon: <AssessmentIcon />,
        label: "Consumo Real",
        description:
          "Compara movimientos reales, inventarios y variaciones de existencias.",
      },
      {
        path: "cmv-general",
        icon: <PaidIcon />,
        label: "CMV General",
        description:
          "Analiza el costo de mercadería vendida y su peso sobre las ventas.",
      },
      {
        path: "desvios",
        icon: <CompareArrowsIcon />,
        label: "Desvíos",
        description:
          "Detecta diferencias entre consumo esperado, real y costos asociados.",
      },
      {
        path: "impacto-economico",
        icon: <SavingsIcon />,
        label: "Impacto Económico",
        description:
          "Traduce desvíos y pérdidas en valores económicos para priorizar acciones.",
      },
      {
        path: "pedido-sugerido",
        icon: <PlaylistAddCheckIcon />,
        label: "Pedido Sugerido",
        description:
          "Sugiere compras según stock actual, consumo proyectado y mínimos definidos.",
      },
    ],
  },
  {
    key: "dashboard",
    path: "dashboard",
    icon: <DashboardIcon />,
    label: "Dashboard",
    areaLabel: "Área Dashboard",
    description:
      "Visualiza el estado general del stock y métricas clave en un solo lugar.",
    children: [
      {
        path: "resumen-semanal",
        icon: <DateRangeIcon />,
        label: "Resumen Semanal",
        description:
          "Revisa la evolución reciente de compras, consumos, mermas y alertas.",
      },
      {
        path: "top-desvios",
        icon: <LeaderboardIcon />,
        label: "Top Desvíos",
        description:
          "Identifica los insumos y productos de venta con mayores diferencias operativas.",
      },
      {
        path: "cmv",
        icon: <PaidIcon />,
        label: "CMV",
        description:
          "Sigue el costo de mercadería vendida y su variación por período.",
      },
      {
        path: "evolucion",
        icon: <ShowChartIcon />,
        label: "Evolución",
        description:
          "Observa tendencias de stock, consumo, costos y eficiencia operativa.",
      },
      {
        path: "alertas",
        icon: <NotificationsActiveIcon />,
        label: "Alertas",
        description:
          "Monitorea faltantes, sobrestock, vencimientos y desvíos relevantes.",
      },
    ],
  },
];

export const stockAreas = stockSections.map((section) => ({
  icon: section.icon,
  label: section.label,
  description: section.description,
  to: `${stockBasePath}/${section.path}`,
}));

export function getStockSectionByPath(sectionPath) {
  return stockSections.find((section) => section.path === sectionPath) || null;
}

export function getStockSubsectionByPath(sectionPath, subsectionPath) {
  const section = getStockSectionByPath(sectionPath);
  const subsection =
    section?.children?.find((item) => item.path === subsectionPath) || null;

  return { section, subsection };
}

export function getStockUserRole(user) {
  return String(user?.user_role || user?.userRole || "")
    .trim()
    .toUpperCase();
}

export function canAccessStockSubsection(subsection, user) {
  if (!Array.isArray(subsection?.allowedRoles) || !subsection.allowedRoles.length) {
    return true;
  }
  const role = getStockUserRole(user);
  return subsection.allowedRoles.includes(role);
}

export function getStockTopBarTitle(pathname = "") {
  const [, modulePath, sectionPath] = pathname.split("/");

  if (modulePath !== "stock") return "Módulo de Stock";

  const section = getStockSectionByPath(sectionPath);
  if (!section) return "Módulo de Stock";

  return `Módulo de Stock / ${section.label}`;
}

export function getStockTopBarBreadcrumbs(pathname = "") {
  const [, modulePath, sectionPath, subsectionPath] = pathname.split("/");

  if (modulePath !== "stock") return null;

  const breadcrumbs = [
    {
      label: "Módulo de Stock",
      to: sectionPath ? "/stock" : null,
    },
  ];

  const section = getStockSectionByPath(sectionPath);
  if (section) {
    breadcrumbs.push({
      label: section.label,
      to: subsectionPath ? `/stock/${section.path}` : null,
    });
  }

  return breadcrumbs;
}
